// eslint-disable-next-line import/prefer-default-export
export const GIFT_CODE_ENCRYPTION_PASSWORD_KEY_PREFIX = 'kamigameGiftCodeEncryptionPasswordKey-';
